export enum FilterByCategory {
  Photocamera = 'Фотокамера',
  Videocamera = 'Видеокамера'
}

export enum ServerFilterValue {
  Photocamera = 'Фотоаппарат'
}
